import store from '../../init/store.js'
import {masterSubmitsQueuedAction, masterSelectsActionForBot} from '../lifecycle/master-submits-actions.js'
import {submitBattleOver} from '../lifecycle/submit-battle-over.js'
import {getCombatantIdFromSelectingString} from '../get-combatant-id-from-selecting-string.js'


/** Offline behavior for new battleState coming in and needing to automatically submit for a bot or cloud queue */
export function offlineCheckForAutoSubmission() {


  const combatantSelectingAction = store.getState().battle.combatantSelectingAction;

  //Check if this is the battle "battle over" submission
  if (combatantSelectingAction === "battle-over") {
    //console.log('submitting again')
    submitBattleOver();
    //TODO: Why was this in here? Might have had to do with auto battles? Some runtime error?

    //Might need to do some sort of "okay handle battle over" callback here. To get us out of battle mode
    return;
  }


  //Check if it's a cloud deal.
  if (combatantSelectingAction.match(/^cloudQueueAction/)) {
    masterSubmitsQueuedAction(combatantSelectingAction);
    return;
  }

  //Check if the newSelectingPerson is a bot. (//isBot check handled within that function.)
  masterSelectsActionForBot(
    //Checks for deadline formatting, etc
    getCombatantIdFromSelectingString(combatantSelectingAction)
  ); //ai handled deeper within this function


}


// WEBPACK FOOTER //
// ./src/battle/offline/offline-check-for-auto-submissions.js